import {BaseFyneAIAppPrefs} from "../fyneai-shared/BaseFyneAIAppPrefs";

export class AppPrefs extends BaseFyneAIAppPrefs {

  private static instance: AppPrefs;

  static getInstance() {
    if (!this.instance) {
      this.instance = new AppPrefs();
    }
    return this.instance;
  }

  private constructor() {
    super();
  }
}
